import { useMemo } from 'react';

import resolveKey from '../../../../utils/components/_resolveKey';
import { DropListOption } from '../DropList';

interface UseDropListIdsOptions<OptionValue> {
  dropListId: number;
  selectedOptions: DropListOption<OptionValue>[];
}

const useDropListIds = <OptionValue, >({ dropListId, selectedOptions }: UseDropListIdsOptions<OptionValue>) => {
  const dropDownContainerId = useMemo(() => `DropList${dropListId}Container`, [dropListId]);

  const selectedItemIds = useMemo(() => (
    selectedOptions.map((selectedOption) => `DropList${dropListId}Item${resolveKey(selectedOption.value as unknown as string, selectedOption.key)}`)
  ), [dropListId, selectedOptions]);

  return {
    dropDownContainerId,
    selectedItemIds,
  };
};

export default useDropListIds;
